import { Component, Input } from '@angular/core';
import { Margin } from '@freelancer/ui/margin';
import { OnlineIndicatorSize } from '@freelancer/ui/online-indicator';
import { FontColor, FontType, TextAlign, TextSize } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-user-profile-summary-online-indicator',
  template: `
    <fl-bit class="OnlineOfflineNotification">
      <fl-online-indicator
        [flMarginRight]="Margin.SMALL"
        [isOnline]="isOnline$ | flAsync"
        [size]="OnlineIndicatorSize.MID"
      ></fl-online-indicator>

      <fl-text
        *ngIf="isOnline$ | flAsync"
        [color]="FontColor.SUCCESS"
        i18n="Im online notification label"
      >
        I'm Online!
      </fl-text>

      <fl-text
        *ngIf="!(isOnline$ | flAsync)"
        [color]="FontColor.MID"
        i18n="Im offline notification label"
      >
        I'm Offline!
      </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-summary-online-indicator.component.scss'],
})
export class UserProfileSummaryOnlineIndicatorComponent {
  Margin = Margin;
  FontColor = FontColor;
  FontType = FontType;
  TextSize = TextSize;
  TextAlign = TextAlign;
  OnlineIndicatorSize = OnlineIndicatorSize;

  @Input() isOnline$: Rx.Observable<boolean>;
}
